export default __webpack_public_path__ + "static/media/spreadingflames.e37bb513.png";